
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import '../css/new-reservation-complete.css';
import $$ from 'Dom7';
export default {
  data: function () {
    return {
      ReservationDetails: {},
      Totalroomsprice: {}
    };
  },

  beforeDestroy() {
    var self = this;
    console.log('componentBeforeDestroy', this);
  },

  methods: {},
  on: {
    pageInit: function (e, page) {
      var finalStepReservation = localStorage.getItem('CompleteReservation'); // pairnw thn opliroforia tou local storage

      finalStepReservation = JSON.parse(finalStepReservation); // kanw parse thn pliroforia tou local storage

      var temnew = localStorage.getItem('ContReservation');
      temnew = JSON.parse(temnew);
      this.$setState({
        ReservationDetails: finalStepReservation,
        Totalroomsprice: temnew
      });
      $$('#GoToPlan').on('click', function () {
        app.f7.views.main.router.navigate('/main/NewCalendar/', {
          transition: 'f7-dive'
        });
      });
      $$('#GoToHome').on('click', function () {
        app.f7.views.main.router.navigate('/main/', {
          transition: 'f7-dive'
        });
      });
      $$('#GoToBookings').on('click', function () {
        app.f7.views.main.router.navigate('/main/reservations/');
      }); // $$('#gotohome').on('click', function () {
      //     app.f7.views.main.router.navigate('/main/')
      // });
    },

    pageBeforeRemove() {}

  },
  id: 'fc951dd624',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=new-reservation-home><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class=backicon id=gotohome><i class="icon icon-back"></i></a></div>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.ReservationDetails?.isOffer, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=title>Offer Created</div>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=title>';
          r += Template7Helpers.t.call(ctx_2, 'BookingComplete', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="page-content newreservationpage"><div class=block-title style="color:black;font-size:22px;line-height: 40px;overflow: hidden;width: 40%;white-space: break-spaces;font-weight:700;">';
      r += Template7Helpers.t.call(ctx_1, 'YourBookingIsCompleted', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=block><div class=row style=font-weight:bold;>';
      r += Template7Helpers.t.call(ctx_1, 'BookingID', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=row>';
      r += c(ctx_1.ReservationDetails.ResIDs, ctx_1);
      r += '</div><br><div class="row col-100"><div style="display: flex;"><div style="font-weight: 700;">Source:</div><div style="margin-left: 15px;">';
      r += c(ctx_1.ReservationDetails.SourceName, ctx_1);
      r += '</div></div></div><div class="row col-100" style="flex-direction: column;"><div style="display: flex;"><div>Date From:</div><div style="margin-left: 15px;">';
      r += c(ctx_1.ReservationDetails.DateFrom, ctx_1);
      r += '</div></div><div style="display: flex;"><div>Date To:</div><div style="margin-left: 15px;">';
      r += c(ctx_1.ReservationDetails.DateTo, ctx_1);
      r += '</div></div></div><div class=list><ul><li><a href=# class="item-link item-content"><div class=""><div class=item-title><div class=item-header style=font-size:small;>';
      r += Template7Helpers.t.call(ctx_1, 'TotalPriceFor', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <b>';
      r += c(ctx_1.ReservationDetails.NumberOfRooms, ctx_1);
      r += ' rooms, ';
      r += c(ctx_1.ReservationDetails.Nights, ctx_1);
      r += ' nights</b><b>, ';
      r += c(ctx_1.Totalroomsprice.totalPriceStepper, ctx_1);
      r += ' €</b></div></div></div></a></li></ul></div><div class=block>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.ReservationDetails?.isOffer, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<p class=row><button id=GoToBookings class="col button button-small button-outline searchbtn color-blue">';
          r += Template7Helpers.t.call(ctx_2, 'GoToMyBookings', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</button></p>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<p class=row><button id=GoToPlan class="col button button-small button-outline searchbtn color-blue">';
      r += Template7Helpers.t.call(ctx_1, 'GoToPlan', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</button></p></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};
    